import React from 'react';
import { connect } from 'react-redux';
import LazyLoad from 'react-lazyload';
import selectors from 'shared/store/selectors';
import {
  Card, Typography, PerformanceTab, Grid, Tags, Modal,
} from 'components';
import TextTruncate from 'react-text-truncate';
import { PRODUCT_SERVICE_TYPE } from 'shared/constant';
// import DefaultBanner from 'assets/images/default-banner.png';
// import ArrowIcon from 'assets/icons/chevron-right.svg';

import './SmartCard.scss';

const SmartCard = ({
  data,
  intl,
  showModal,
  onClose = () => {},
}) => {
  const {
    id,
    bannerSrc,
    fundName,
    investmentObjective,
    tags,
    geography,
    productType,
    performanceData,
    realEstateData,
    investmentServiceData,
  } = data;

  //   const {
  //     type, investmentHorizon, targetNetIRR, targetNetMultiple,
  //   } = realEstateData;

  return (
    <Modal isCatalogue showModal={showModal} onClose={onClose} title={intl.formatMessage({ id: 'product.overview' })}>
      <div className="product">
        <LazyLoad className="product__header" style={{ backgroundImage: `url(${bannerSrc})` }}>
          {/* <header> */}

          {/* <div className="product__header__type">
                <Typography type="span" isSmall isTextColorInverted value={productType} />
            </div> */}

          <span className="spacer" />


          <div className="product__header__title">
            <Typography type="mainTitle" textAlign="left" value={fundName} customClass="product__header__title__text" />
            {/* <img src={ArrowIcon} alt={fundName} /> */}
          </div>

          {/* @Todo Replace span with TAG component and mapped value */}
          {/* {tags && tags.map((tag, idx) => (
                        <span key={`tag-${idx}`}>{tag}</span>
                    ))} */}
          <Tags data={tags} geography={geography} id={id} key={`key-${id}`} />

          {/* <Typography type="paragraph" customClass="product__header__desc" isSmall isTextColorInverted value={description} /> */}
          <article className="product__header__desc">
            <TextTruncate
              line={3}
              element="p"
              truncateText="…"
              text={investmentObjective || ''}
            />
          </article>

          {/* </header> */}
        </LazyLoad>

        <Card>
          <Card.Body>

            {productType === PRODUCT_SERVICE_TYPE.MUTUAL_FUND && (
            <PerformanceTab
              contents={performanceData}
            />
            )}

            {productType === PRODUCT_SERVICE_TYPE.REAL_ESTATE && (
            <>
              <Grid>
                <Grid displayByBlock>
                  <Typography type="highlight" value={realEstateData && realEstateData.type} />
                  <Typography type="span" isLightColor isSmall value={intl.formatMessage({ id: 'product.type' })} />
                </Grid>
                <Grid displayByBlock>
                  <Typography type="highlight" value={realEstateData.investmentHorizon} />
                  <Typography type="span" isLightColor isSmall value={intl.formatMessage({ id: 'product.investmentHorizon' })} />
                </Grid>
              </Grid>

              <Grid>
                <Grid displayByBlock>
                  <Typography type="highlight" value={realEstateData.targetNetIRR} />
                  <Typography type="span" isLightColor isSmall value={intl.formatMessage({ id: 'product.targetNetIRR' })} />
                </Grid>
                <Grid displayByBlock>
                  <Typography type="highlight" value={realEstateData.targetNetMultiple} />
                  <Typography type="span" isLightColor isSmall value={intl.formatMessage({ id: 'product.targetNetMultiple' })} />
                </Grid>
              </Grid>
            </>
            )}

            {productType === PRODUCT_SERVICE_TYPE.INVESTMENT_SERVICE && (
            <>
              <Grid>
                <Grid displayByBlock>
                  <Typography type="highlight" value={investmentServiceData.type} />
                  <Typography type="span" isLightColor isSmall value={intl.formatMessage({ id: 'product.type' })} />
                </Grid>
                <Grid displayByBlock>
                  <Typography type="highlight" value={investmentServiceData.investmentHorizon} />
                  <Typography type="span" isLightColor isSmall value={intl.formatMessage({ id: 'product.investmentHorizon' })} />
                </Grid>
              </Grid>

              <Grid>
                <Grid displayByBlock>
                  <Typography type="highlight" value={realEstateData.targetNetIRR} />
                  <Typography type="span" isLightColor isSmall value={intl.formatMessage({ id: 'product.targetNetIRR' })} />
                </Grid>
                <Grid displayByBlock>
                  <Typography type="highlight" value={investmentServiceData.targetNetMultiple} />
                  <Typography type="span" isLightColor isSmall value={intl.formatMessage({ id: 'product.targetNetMultiple' })} />
                </Grid>
              </Grid>
            </>
            )}
          </Card.Body>
        </Card>

        <a href={`${process.env.REACT_APP_CATALOGUE_URL}/product-details/${id}`} target="_blank" className="nw-button nw-button--tertiary btn-full-details" rel="noopener noreferrer">
          {intl.formatMessage({ id: 'product.seeFullDetails' })}
        </a>

      </div>
    </Modal>
  );
};

const mapStateToProps = state => ({
  data: selectors.getSelectedProductCard(state),
});

export default connect(mapStateToProps, null)(SmartCard);
